// src/App.js
import React, { useState, useEffect } from 'react';
import {
  Routes, Route, Navigate, useLocation, useParams,
} from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { trackPageView } from './utils/analytics';
import { setSiteSchema } from './utils/seo'; // CHANGED: import setSiteSchema
import BootSequence from './components/Effects/BootSequence';
import CRTOverlay from './components/Effects/CRTOverlay';
import Terminal from './components/BBS/Terminal';
import ArchiveList from './pages/ArchiveList';
import ArchiveView from './pages/ArchiveView';
import LinksBoard from './pages/LinksBoard';
import GamesArcade from './pages/GamesArcade';
import LiveFeed from './pages/LiveFeed';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import NotFound from './pages/NotFound';
import AmbientAudio from './components/Effects/AmbientAudio';
import Subscribe from './pages/Subscribe';

// Redirect helper for old /stories/:slug URLs (preserves SEO + bookmarks)
function OldStoryRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/archives/${slug}`} replace />;
}

// detect search engine crawlers so they skip the boot animation
function isCrawler() {
  return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebot|ia_archiver|semrushbot|ahrefsbot|mj12bot|petalbot|applebot/i
    .test(navigator.userAgent);
}

function App() {
  // crawlers start already "booted" — content is immediately visible
  const [booted, setBooted] = useState(() => isCrawler());
  const [showScanlines] = useState(true);
  const location = useLocation();
  const crawlerMode = isCrawler(); // CHANGED: cache the check

  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  // CHANGED: inject WebSite JSON-LD once on mount
  useEffect(() => {
    setSiteSchema();
  }, []);

  return (
    <AuthProvider>
      <div className="bbs-screen">
        {/* CHANGED: hide visual effects for crawlers — they add no SEO value
            and can interfere with content parsing */}
        {!crawlerMode && <CRTOverlay enabled={showScanlines} />}
        {!crawlerMode && <AmbientAudio />}

        {!booted ? (
          <BootSequence onComplete={() => setBooted(true)} />
        ) : (
          <div className="bbs-content">
            <Routes>
              <Route path="/" element={<Terminal />} />

              {/* Archives (formerly Stories) */}
              <Route path="/archives" element={<ArchiveList />} />
              <Route path="/archives/:slug" element={<ArchiveView />} />

              {/* Redirects from old /stories URLs */}
              <Route
                path="/stories"
                element={<Navigate to="/archives" replace />}
              />
              <Route
                path="/stories/:slug"
                element={<OldStoryRedirect />}
              />

              <Route path="/links" element={<LinksBoard />} />
              <Route path="/games" element={<GamesArcade />} />
              <Route path="/games/:gameId" element={<GamesArcade />} />
              <Route path="/feed" element={<LiveFeed />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={<AdminDashboard />}
              />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        )}
      </div>
    </AuthProvider>
  );
}

export default App;